module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("TIMELINE OF MODJESKA’S LIFE AND CAREER")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12 October 1840")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Helena Jadwiga Mizel born to Józefa Bendowa and unknown father in Kraków, Poland. Her half-brothers are Józef, Szymon, and Feliks Benda and, if Micha"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v(" Opid is her father, Adolf Opid. Her full (?) sister is Józefa.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("26 April 1848")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Austrian bombardment of Kraków.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("July 1850")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Great Kraków fire, in which the Benda family’s properties are seriously damaged.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("27 January 1861")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Helena gives birth to Rudolf, her son by Gustaw Zimajer.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("July 1861")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("The newly named Modrzejewska debuts on the provincial stage in Bochnia. Soon after, her new troupe begins to tour towns in the Austrian partition of Poland.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("10 April 1862")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Helena gives birth to Maria, her daughter by Zimajer. Maria dies in spring 1865.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("November 1862–Spring 1863")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modrzejewska engaged by the Lwów Theatre.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("January 1863–December 1864")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Polish uprising against the Russian authorities.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("March 1863–August 1865")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modrzejewska engaged by the Czerniowce Theatre.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("August 1865")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modrzejewska leaves Zimajer, taking Rudolf with her.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Fall 1865–Spring 1869")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modrzejewska engaged by the Kraków Theatre.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("1866")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Zimajer abducts Rudolf. Modrzejewska recovers her son four years later.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("12 September 1868")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modrzejewska marries Karol Bo"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/szdot.jpg",
      "width": "7"
    }
  }), _vm._v("enta Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("October–December 1868")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modrzejewska debuts successfully at the Warsaw Imperial Theatres.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Fall 1869–June 1876")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modrzejewska reigns as prima donna of Warsaw Imperial Theatres.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("13 July 1876")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modrzejewska’s “colonial party” departs for America.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("20 August 1877")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("The renamed Helena Modjeska debuts successfully in San Francisco at the California Theatre.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("22 December 1877")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska’s first East Coast tour begins in New York.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("October 1879–March 1880")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska’s return to Poland and first guest tour.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("22 January 1880")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Funeral of Ignacy Neufeld, schoolboy who committed suicide after giving Modjeska a wreath in Polish national colors.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("1 May 1880")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska’s London debut at the Court Theatre.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("January–March 1882")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska’s second guest tour in Poland.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("October 1882")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska returns from England to the American stage.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("October 1884–February 1885")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska’s third guest tour in Poland.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Spring 1885")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska guest tours in England and Ireland.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("28 December 1885")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Ralph Modjeski and Felicja Bendówna marry in New York.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Summer 1888")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska and Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski purchase the Pleasants’ ranch in Southern California and begin transforming it into their American home. They name the ranch Arden.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Fall 1889–Spring 1890")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska tours with Edwin Booth.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("Fall 1890–Spring 1891")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska’s fourth guest tour in Poland.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("19 May 1893")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska gives nationalist speech at Chicago Columbian Exhibition.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("October 1894–Summer 1895")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska’s fifth guest tour in Poland. The Russian authorities forbid her appearances in Warsaw in retaliation for her May 1893 speech in Chicago.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("January 1896–November 1897")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska suffers a stroke and must undergo a long convalescence at Arden.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("July 1901")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska visits Poland and plays some benefit performances.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("January–April 1903")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska’s last guest tour of Poland, during which she stars in Wyspia"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski’s "), _c('em', [_vm._v("Protesilaus and Laodamia")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("2 May 1905")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska’s benefit held at the Metropolitan Opera House in New York.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("23 August 1906")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Arden is sold and Modjeska and Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski move to Tustin. They subsequently move to Bay Island in 1908 (present-day Newport, California).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("8 April 1909")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska dies in Newport, California.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("17 July 1909")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table2"
  }, [_vm._v("Modjeska interred in Kraków’s Rakowicki Cemetery.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aa3b0df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/timeline_of_modjeskas_lifecareer.vue
// module id = 78
// module chunks = 0